<template>
  <main>
    <ProgressSpinner v-if="isLoading" class="top-50" />

    <div class="text-center shadow-2 mb-2">
      <h2>{{ selected.name }}</h2>
      <h4>
        N°
        <span
          ><h1 class="inline">{{ selected.number }}</h1></span
        >
      </h4>
    </div>

    <div class="">
      <div class="">
        <div class="border-1 border-round-sm p-3 inline-block">
          <div class="mt-3">
            <div class="flex flex-column gap-2">
              <label for="label">Titre</label>

              <InputText
                id="label"
                type="text"
                v-model="help.title"
                @blur="updateHelp(help)"
                placeholder="Titre"
              />
            </div>
            <div class="flex flex-column gap-2">
              <label for="info">Détails</label>
              <Editor
                v-model="help.details"
                editorStyle="height: 320px"
                :modules="{ toolbar: toolbarOptions }"
              >
                <!-- Conserver les lignes ci-dessous pour éviterun bg d'affichage de primevue -->
                <!-- <template #toolbar>
                  <span class="ql-formats"> 
                    <button class="ql-bold"></button>
			<button class="ql-italic"></button>
			<button class="ql-underline"></button>
                  </span>
                </template> -->
              </Editor>
            </div>

            <Message severity="info" v-if="message">{{ message }}</Message>
            <Button label="Valider" @click="updateHelp(help)" />
          </div>
        </div>
      </div>
    </div>
    <!-- <h3>Helps pour id {{ helpId }}</h3>
    <div v-for="(item, index) in help.list" :key="index">
      {{ item }}
    </div> -->
  </main>
</template>
<script>
// import TheWelcome from '../components/TheWelcome.vue'
// import { ref, watch, onMounted, nextTick } from "vue";

export default {
  data() {
    return {
      isLoading: false,
      message: null,

      toolbarOptions: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],

        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],

        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ["link"],
        ["image"],
        // ['video'],
      ],

      //  images = ref([])

      help: {},
    };
  },
  components: {},
  props: {
    helpId: Number,
    helpNumber: Number,
    selected: Object,
  },
  async mounted() {
    try {
      const resp = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/helps/getHelp",
        {
          method: "POST",
          body: JSON.stringify({ id: this.helpId }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      );
      // console.log(await resp.json());
      const json = await resp.json();
      console.log(json);
      
      this.help = json;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async getHelp(helpId) {
      try {
      const resp = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/helps/getHelp",
        {
          method: "POST",
          body: JSON.stringify({ id: helpId }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      );
      // console.log(await resp.json());
      const json = await resp.json();
      console.log(json);
      
      this.help = json;
    } catch (error) {
      console.log(error);
    }
    },
    async updateHelp() {
      this.message = "";

      try {
        const res = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/api/v1/helps/updateHelp",
          {
            method: "POST",
            body: JSON.stringify({ id: this.helpId, ...this.help }),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`,
            },
          }
        );
        console.log(res);
        if (res.status === 200) {
          this.message = "Ok";
        } else {
          this.message = "Pas ok";
        }

        return res;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
  helpId() {
    this.getHelp(this.helpId) 
  },
  },
};
</script>
<style>
.wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.item {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
